import '.ez{line-height:1.375rem;}.ssr-plugin'
import '.c5{font-size:0.875rem;}.ssr-plugin'
import '.a{display:flex;}.ssr-plugin'
import '.m{flex-direction:column;}.ssr-plugin'
import '.ab{align-items:stretch;}.ssr-plugin'
import '.f0{gap:0.38rem;}.ssr-plugin'
import '.eu{padding:0.5rem 1rem;}.ssr-plugin'
import '.n{align-items:center;}.ssr-plugin'
import '.aj{gap:0.5rem;}.ssr-plugin'
import '.ba{flex-grow:1;}.ssr-plugin'
import '.bd{padding:0px;}.ssr-plugin'
import '.bb{border:none;}.ssr-plugin'
import '.f1{outline:none;}.ssr-plugin'
import '.f2{background:transparent;}.ssr-plugin'
import { Style, styled } from 'inlines'
import {
  KeyboardEvent,
  MutableRefObject,
  forwardRef,
  FocusEventHandler,
  KeyboardEventHandler,
} from 'react'
import { Text } from '../../typography/Text'

export type TextInputProps = {
  text: string
  placeholder?: string
  label?: string
  errorMessage?: string
  style?: Style
  ref?: MutableRefObject<HTMLInputElement>
  setText: (text: string) => void
  onBlur?: FocusEventHandler<HTMLInputElement>
  onKeyDown?: KeyboardEventHandler<HTMLInputElement>
}

export const BorderlessTextInput = forwardRef<HTMLInputElement, TextInputProps>(
  (
    {
      text,
      placeholder,
      label,
      errorMessage,
      style,
      setText,
      onBlur,
      onKeyDown,
    }: TextInputProps,
    ref,
  ) => {
    const errorStateOn = !!errorMessage
    const handleKeyDown = (event: KeyboardEvent<HTMLInputElement>) => {
      if (onKeyDown) {
        onKeyDown(event)
      }
    }

    return (
      <styled.div className="ez c5 a m ab f0 eu"
        style={{
          '&:has(:disabled)': {
            cursor: 'not-allowed',
          },
          ...style,
        }}
      >
        <div className="a n aj"
          style={{
            background: errorStateOn
              ? 'var(--shades-red-100)'
              : 'var(--shades-white)',
          }}
        >
          {label && <styled.div>{label}</styled.div>}
          <styled.input className="ba bd bb f1 f2"
            placeholder={placeholder}
            value={text}
            onChange={(e) => setText(e.target.value)}
            onBlur={onBlur}
            onKeyDown={handleKeyDown}
            ref={ref}
            style={{
              '&::placeholder': {
                color: errorStateOn
                  ? 'var(--shades-red-400)'
                  : 'var(--gray-300)',
                userSelect: 'none',
              },
              '&:disabled': {
                cursor: 'not-allowed',
              },
            }}
          ></styled.input>
        </div>
        {errorStateOn && (
          <Text.ExtraSmall style={{ color: 'var(--shades-red-600)' }}>
            {errorMessage}
          </Text.ExtraSmall>
        )}
      </styled.div>
    )
  },
)

BorderlessTextInput.displayName = 'BorderlessTextInput'
